{
    "coordinates": [
        -84.14373805169592,
        169.52049078601476
    ],
    "tooltip": "Hanson",
    "title": "Hanson Formation",
    "country": "Antarctica",
    "period": "Jurassic",
    "alt": "TODO"
}